import { styled } from "@mui/material/styles";

const ItemsMain = styled("div")(({ theme }) => ({
  margin: "0 auto",
  width: "90%",
}));

export { ItemsMain };
